// The assistant conversation survives a page reload but not the browser
// session, and is dropped on logout: it can quote plant data the next user of
// the same browser should not see.
const CONVERSATION_KEY = 'assistant-conversation'

const isValidTurn = (turn) => {
  return turn && (turn.role === 'user' || turn.role === 'assistant') && typeof turn.content === 'string'
}

export const loadAssistantConversation = () => {
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(CONVERSATION_KEY))
    return Array.isArray(stored) ? stored.filter(isValidTurn) : []
  } catch (exception) {
    return []
  }
}

/**
 * Restores the conversation, telling apart a turn that never finished: a
 * message still marked as unfinished means its answer never completed — the
 * page went away mid-stream, or the stream died. Its partial text would read
 * as a finished answer, so it is dropped and reported as interrupted.
 */
export const restoreAssistantConversation = () => {
  const stored = loadAssistantConversation()
  const last = stored[stored.length - 1] || {}
  return last.role === 'assistant' && last.unfinished === true
    ? { messages: stored.slice(0, -1), interrupted: true }
    : { messages: stored, interrupted: false }
}

export const saveAssistantConversation = (messages) => {
  try {
    window.sessionStorage.setItem(CONVERSATION_KEY, JSON.stringify(messages))
  } catch (exception) {
    // storage can be full or disabled; the conversation just will not persist
  }
}

export const clearAssistantConversation = () => {
  window.sessionStorage.removeItem(CONVERSATION_KEY)
}
